<script lang="ts" module>
  import type { BaseProps } from "#lib/internal/types"

  export type CollapsibleTriggerProps = BaseProps<"button"> & {
    onchange?: (open: boolean) => void
  }
</script>

<script lang="ts">
  import { useActions } from "#lib/internal/helpers/useActions"
  import type { Snippet } from "svelte"
  import { getCollapsibleRootContext } from "./CollapsibleRoot.svelte"

  type Props = CollapsibleTriggerProps & { children?: Snippet }

  let { onchange, children, use = [], ...restProps }: Props = $props()

  const ctx = getCollapsibleRootContext()
</script>

<button
  {...restProps}
  use:useActions={use}
  onclick={() => {
    $ctx.open = !$ctx.open
    onchange?.($ctx.open)
  }}
  data-state={$ctx.open ? "open" : "closed"}
  data-disabled={$ctx.disabled ? "true" : undefined}
  disabled={$ctx.disabled}
  type="button"
>
  {@render children?.()}
</button>
